let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7GYBQ")).then(() => parcelRequire('jc4rP'));